import { StyledButton } from './Button.styles';
import type { ButtonProps } from './Button.types';

export const Button = ({
  variant = 'primary',
  size = 'medium',
  fullWidth = false,
  selected,
  children,
  ...props
}: ButtonProps) => (
  <StyledButton
    data-variant={variant}
    data-size={size}
    $fullWidth={fullWidth}
    {...(selected !== undefined
      ? { 'aria-pressed': selected, 'data-selected': selected || undefined }
      : {})}
    {...props}
  >
    {children}
  </StyledButton>
);
